export default "__VITE_ASSET__CItvKzOA__"